/* eslint-disable */

export interface PossibleTypesResultData {
    possibleTypes: {
        [key: string]: string[];
    };
}
const result: PossibleTypesResultData = {
    possibleTypes: {
        ContestOverviewBriefElement: [
            'ContestOverviewTextElement',
            'ContestOverviewTextAreaElement',
            'ContestOverviewMultipleChoiceImageElement',
            'ContestOverviewSlidersElement',
            'ContestOverviewFilesElement',
            'ContestOverviewChoiceElement',
        ],
        StructuredBriefFields: [
            'ProjectBriefFields',
            'SquarespaceApiBriefFields',
            'SquarespaceBriefFields',
            'PreziBriefFields',
            'SquareOnlineStoreBriefFields',
            'PacklaneBriefFields',
            'NationBuilderBriefFields',
            'SquareOnlineStoreRestaurantBriefFields',
            'WebBuilderBriefFields',
            'SquareOnlineStoreEcommerceBriefFields',
            'LogoDesignBriefFields',
            'FacebookAdBriefFields',
            'FacebookAdV2BriefFields',
            'ProjectInternalBriefFields',
            'SquarespaceWebBriefFields',
            'SquarespaceApiV2BriefFields',
            'SquareOnlineSelfServeBriefFields',
            'SquareOnlineCompleteBriefFields',
            'DynamicBriefFields',
        ],
        DynamicField: [
            'TextField',
            'ChoiceField',
            'MultiChoiceField',
            'URLField',
            'MultiURLField',
            'BudgetField',
            'DateField',
            'FilesField',
            'TextAreaField',
            'BooleanField',
            'NumberField',
        ],
        Job: ['JobForClient', 'JobForDesigner'],
        ChatEventData: [
            'ChatEventMessageContent',
            'ChatEventFileMessageContent',
            'ChatEventExternalEventContent',
            'ChatEventMessageWithFilesContent',
        ],
        ExternalEvent: ['ProjectEvent'],
        ProjectEventContent: [
            'AuthoriseAvailableForProfileContent',
            'RevokeAvailableForProfileContent',
            'StartAutoFinishProjectTimerContent',
            'CancelAutoFinishProjectTimerContent',
            'AutoFinishProjectReminderContent',
            'DesignTransferAgreementSignedContent',
            'ProjectDescriptionCreatedContent',
            'ProjectCreatedContent',
            'ProjectMessageContent',
            'ProjectCancelledContent',
            'ProjectUncancelledContent',
            'ProjectUnfinishedContent',
            'ProjectFinishedContent',
            'ProjectLockedContent',
            'ProjectUnlockedContent',
            'ProjectTitleUpdatedContent',
            'ProjectDetailsEditedContent',
            'ProjectFileMessageCreatedContent',
            'ProjectFolderCreatedContent',
            'ProjectFolderUpdatedContent',
            'ProjectFolderDeletedContent',
            'ProjectFileUploadedContent',
            'ProjectFileStageChangesContent',
            'ProjectDeliverableFileUploadedContent',
            'ProjectMarkDeliverableFileContent',
            'ProjectUnmarkDeliverableFileContent',
            'NoDesignerResponseContent',
            'InvoiceCreatedContent',
            'InvoiceRevisionRequestedContent',
            'InvoiceUpdatedContent',
            'InvoiceRevisedContent',
            'InvoicePaidContent',
            'InvoicePaymentHeldContent',
            'InvoiceResentContent',
            'InvoiceExpiredContent',
            'InvoiceExpirationReminderContent',
            'InvoiceCancelledContent',
            'InvoiceRefundedContent',
            'InvoiceAutoReleaseTimerStartedContent',
            'InvoiceAutoReleaseTimerCancelledContent',
            'InvoiceItemReleaseRequestDeclinedContent',
            'SuggestProjectCompletionContent',
            'ProjectEventUnknown',
            'InvoiceItemReleaseRequestedContent',
            'InvoiceItemPaymentReleasedContent',
            'InvoicePaymentReleasedContent',
            'ProjectTemplateAddedContent',
        ],
        YourProjectsItem: ['YourProjectsItemProjectDraft', 'YourProjectsItemProject'],
        YourProjectsProjectDraftContextMessageActions: [
            'YourProjectsProjectDraftContextMessageActionsProjectDraft',
        ],
        YourProjectsProjectContextMessageActions: [
            'YourProjectsProjectContextMessageActionsCompletedProject',
            'YourProjectsProjectContextMessageActionsInvitedProject',
            'YourProjectsProjectContextMessageActionsStartedProject',
            'YourProjectsProjectContextMessageActionsLockedProject',
            'YourProjectsProjectContextMessageActionsCanceledProject',
        ],
        ProjectContextMessageAndActions: [
            'ContextMessageAndActionsCompletedProject',
            'ContextMessageAndActionsLockedProject',
            'ContextMessageAndActionsStartedProject',
            'ContextMessageAndActionsInvitedProject',
        ],
        ContestContextMessageAndActions: [
            'ContextMessageAndActionsOnHoldContest',
            'ContextMessageAndActionsRefundedContest',
            'ContextMessageAndActionsLockedContest',
            'ContextMessageAndActionsOpenContest',
            'ContextMessageAndActionsSelectingFinalistContest',
            'ContextMessageAndActionsFinalRoundContest',
            'ContextMessageAndActionsSelectingWinnerContest',
            'ContextMessageAndActionsWonContestMultipleWinners',
            'ContextMessageAndActionsWonContestSingleWinner',
        ],
        OrderWorkSubItem: ['OrderWorkSubItemProject', 'OrderWorkSubItemContest'],
        WorkItem: [
            'ContestWorkItem',
            'ContestDraftWorkItem',
            'ProjectWorkItem',
            'ProjectDraftWorkItem',
            'CreateBriefWorkItem',
            'OrderWorkItem',
        ],
    },
};
export default result;
